import routerOptions0 from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}